module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"open":"Abrir","close":"Fechar","sidebar":"barra lateral"},"en":{"open":"Open","close":"Close","sidebar":"sidebar"}}')
  delete Component.options._Ctor
}
